import "./css/LoaderContainer.css";

import React from "react";

function LoaderContainer(props) {
  return (
    <div
      className={`loader-container ${props.className}`}
      style={{
        ...props.style,
        width: props.fullscreen && "100vw",
        height: props.fullscreen && "100vh",
      }}
    >
      {props.children}
    </div>
  );
}

export default LoaderContainer;
